{
  "id": "campaign-152",
  "name": "Wildflower Fields",
  "seed": "campaign:152",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".......x...x...k....",
    "....................",
    "......x...........#.",
    "..Y.....x.......T...",
    "..................T.",
    "......mmm...........",
    ".............#......",
    "....................",
    ".............T......",
    "..T...............h.",
    ".............T......",
    "..#......Y.....k....",
    "...T..........T...T.",
    ".............x......",
    "....................",
    ".#...~..............",
    "....~~~.....T.......",
    ".x...~h.......h.#...",
    "....................",
    "S..................."
  ],
  "critters": [
    {
      "kind": "fox",
      "x": 16,
      "y": 10
    },
    {
      "kind": "stag",
      "x": 9,
      "y": 19
    },
    {
      "kind": "deer",
      "x": 13,
      "y": 11
    },
    {
      "kind": "deer",
      "x": 12,
      "y": 11
    },
    {
      "kind": "fox",
      "x": 2,
      "y": 0
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 16,
      "y": 7
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 9
    },
    {
      "kind": "gas",
      "x": 17,
      "y": 8
    },
    {
      "kind": "gas",
      "x": 13,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 19,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 16,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 18,
      "y": 3
    },
    {
      "kind": "rare",
      "x": 5,
      "y": 16
    }
  ],
  "hills": [
    {
      "x": 10,
      "y": 3,
      "w": 5,
      "h": 5
    },
    {
      "x": 1,
      "y": 7,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 152,
  "biome": "meadow",
  "par": {
    "reel": 13963,
    "push": 11705,
    "selfPropelled": 10800,
    "tractor": 8880,
    "zeroTurn": 7557,
    "fairway": 4177
  },
  "goldTime": {
    "reel": 13963,
    "push": 11705,
    "selfPropelled": 10788,
    "tractor": 8805,
    "zeroTurn": 7485,
    "fairway": 4177
  },
  "routeTries": {
    "par": {
      "reel": 22,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 18
    },
    "gold": {
      "reel": 22,
      "push": 0,
      "selfPropelled": 25,
      "tractor": 25,
      "zeroTurn": 25,
      "fairway": 18
    }
  }
}
